import FooterSection from "../components/layout/FooterSection.js";
import HeroSec from "../components/layout/HeroSec.js";
import img_example_2 from '../assets/imgs_optimized/img_example_2.webp';

function Contact() {
    return (
        <>
            <div>
                <HeroSec title="Contacto" />
                <div className='flex justify-center mt-16'>
                    <div className='max-w-8xl w-full px-5 lg:px-24'>
                        <div className="flex gap-8 items-center w-full justift-center">
                            <img className='object-contain' src={img_example_2} alt='img_st_1' />
                            <div className='flex-1' style={{ minWidth: "16rem" }}>
                                <h2 className='text-4xl text-primary'>¿Tienes alguna pregunta?</h2>
                                <div className='space-y-10 mt-10'>
                                    <p className="text-xl">
                                        Duis tristique diam id lacus consectetur, sed lacinia augue lobortis. Etiam viverra lacus nec metus auctor consectetur. Maecenas posuere arcu vel tortor ultricies commodo.
                                        Duis tristique diam id lacus consectetur, sed lacinia augue lobortis. Etiam viverra lacus nec metus auctor consectetur. Maecenas posuere arcu vel tortor ultricies commodo. .
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="grid gap-x-16 gap-y-20 mt-20 grid-cols-3">
                            <div className="flex item-center gap-5 items-center flex-1">
                                <img src={img_example_2} alt="logo" className="w-32 h-32 rounded-full p-0" />
                                <div>
                                    <h3 className="text-3xl text-primary">Lorem ipsum</h3>
                                    <div className="mt-3 text-lg font-semibold">Julián González</div>
                                    <div className="text-lg">correo@correo.com</div>
                                    <div className="text-lg">+34 666 666 666</div>
                                </div>
                            </div>
                            <div className="flex item-center gap-5 items-center flex-1">
                                <img src={img_example_2} alt="logo" className="w-32 h-32 rounded-full p-0" />
                                <div>
                                    <h3 className="text-3xl text-primary">Lorem ipsum</h3>
                                    <div className="mt-3 text-lg font-semibold">Julián González</div>
                                    <div className="text-lg">correo@correo.com</div>
                                    <div className="text-lg">+34 666 666 666</div>
                                </div>
                            </div>
                            <div className="flex item-center gap-5 items-center flex-1">
                                <img src={img_example_2} alt="logo" className="w-32 h-32 rounded-full p-0" />
                                <div>
                                    <h3 className="text-3xl text-primary">Lorem ipsum</h3>
                                    <div className="mt-3 text-lg font-semibold">Julián González</div>
                                    <div className="text-lg">correo@correo.com</div>
                                    <div className="text-lg">+34 666 666 666</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterSection />
        </>
    );
}

export default Contact;